import { action, computed, observable, reaction, runInAction } from "mobx";
import { CreditProviderEndpoints } from "../endpoints/CreditProviderEndpoints";
import { IOrganisationProviderProductStore, OrganisationProductSummary } from "../types/OrganisationProviderProductStoreTypes";

export class OrganisationProviderProductStore implements IOrganisationProviderProductStore {
	@observable isLoading: boolean;
	@observable bulkActionLoading: boolean;
	@observable hasError: boolean;
	@observable totalCount: number;
	@observable pageNo: number;
	@observable availableOrganisations: OrganisationProductSummary[];

	constructor(providerId: string, productId: string) {
		this.reset();
		reaction(
			() => this.pageNo,
			() => this.getAvailableOrganisations(providerId, productId)
		)
	}

	@computed get pageSize() {
		return 10;
	}

	@action setPageNo = (pageNo: number) => {
		if (pageNo !== this.pageNo) {
			this.pageNo = pageNo;
		}
	}

	@action reset = () => {
		this.isLoading = false;
		this.hasError = false;
		this.totalCount = 0;
		this.pageNo = 1;
		this.availableOrganisations = [];
	}

	@action getAvailableOrganisations = async (providerId: string, productId: string) => {
		this.isLoading = true;
		this.hasError = false;

		const result = await CreditProviderEndpoints.getAvailableProductOrganisations(providerId, productId, this.pageNo, this.pageSize);
		runInAction(() => {
			this.availableOrganisations = result.data;
			this.setPageNo(result.pageNo);
			this.totalCount = result.totalCount;
			this.isLoading = false;
		});
	}

	@action setBulkActionForAll = async (enableForAll:boolean, providerId: string, productId: string) => {
		// if toggle value is false then just update the enableForALL value
		this.bulkActionLoading = true;
		this.hasError = false;

		const result = await CreditProviderEndpoints.toggleProductForOrganisation(providerId, productId, enableForAll);
		runInAction(async () => {
			if (result) {
				await this.getAvailableOrganisations(providerId, productId);
				runInAction(() => {
					this.bulkActionLoading = enableForAll;
				});
				return;
			}
			this.hasError = !result;
			this.bulkActionLoading = false;
		});
	}

	@action updateOrganisationProductDetail = async (data: OrganisationProductSummary) => {
		this.isLoading = true;
		this.hasError = false;

		const isSuccess = await CreditProviderEndpoints.updateOrganisationProductDetail(data);
		runInAction(() => {
			if (isSuccess) {
				this.getAvailableOrganisations(data.providerId, data.providerProductId);
				this.isLoading = false;
				return;
			}

			this.hasError = true;
			this.isLoading = false;
		})
	}
}